<section>
  <h1 class="mat-headline-4">Contact Us</h1>
</section>
<div class="content comp">
  <div class="contact text-left">
    <form [formGroup]="form" (submit)="submit()">
      <div class="custom-field {{size.width() > 500 ? 'large' : 'max'}}" [class.has-error]="form.get('name')!.errors">
          <label>Name</label>
          <input matInput placeholder="John Doe" type="text" formControlName="name">
          <ng-container *ngTemplateOutlet="errorRender; context: { $implicit: 'name', label: 'Name' }"></ng-container>

      </div>
      <div class="custom-field {{size.width() > 500 ? 'large' : 'max'}}" [class.has-error]="form.get('phone')!.errors">
          <label>Mobile Number</label>
          <input matInput type="tel" formControlName="phone" placeholder="99999999">
          <ng-container *ngTemplateOutlet="errorRender; context: { $implicit: 'phone', label: 'Mobile Number' }"></ng-container>

      </div>
      <div class="custom-field max" [class.has-error]="form.get('email')!.errors">
          <label>Email</label>
          <input matInput placeholder="example@email.com" type="text" formControlName="email">
          <ng-container *ngTemplateOutlet="errorRender; context: { $implicit: 'email', label: 'Email' }"></ng-container>

      </div>
      <div class="custom-field max area" [class.has-error]="form.get('enquiry')!.errors">
          <label>Message</label>
          <textarea placeholder="Your message goes here" formControlName="enquiry"></textarea>
          <ng-container *ngTemplateOutlet="errorRender; context: { $implicit: 'enquiry', label: 'Message' }"></ng-container>

      </div>

      <button mat-flat-button type="submit" class="w-full mt-4 mb-8" [disabled]="isSubmitting()">Send Message</button>

      <p class="disclaimer mt-0 mx-6 text-center">By submitting, you are providing us the the above details and you acknowledge that you have read and agreed to our <a paint="primary" routerLink="/privacy-policy" target="_blank">privacy policy</a>.</p>

      <div class="socials f-main-around f-cross-center cgap-8 rgap-8 f-wrap">
        <a href="https://www.facebook.com/cloudigo" target="_blank" aria-label="Contact us via Facebook: facebook.com/cloudigo" mat-stroked-button rounded color="primary">
          <mat-icon svgIcon="logo:facebook"></mat-icon>
          <span>Talk to us on Facebook</span>
        </a>

        <a href="mailto:support@cloudigo.app" aria-label="Contact us via Email: support@cloudigo.app" mat-stroked-button>
          <mat-icon>email</mat-icon>
          <span>support&#64;cloudigo.app</span>
        </a>

        <a href="tel:+35620991100" aria-label="Contact us via Phone: 20991100" mat-stroked-button>
          <mat-icon>phone</mat-icon>
          <span>+356 20991100</span>
        </a>
      </div>
    </form>
  </div>
</div>

<ng-template #errorRender let-field let-label="label">
  @if(form.get(field)?.touched && form.get(field)?.errors; as error){
    <mat-error>
      @if(error.required){
        {{label}} is required
      } @else if(error.email){
        {{label}} is not valid
      } @else if(error.bad){
        Please enter a different {{label}}
      } @else if(error.matDatepickerMax){
        You must be at least 16 years old to register
      } @else if(error.matDatepickerMin){
        You can't possibly be this old... right?
      } @else if(error.age){
        You must be at least 16 years old
      } @else {
        {{label}} is invalid
      }
    </mat-error>
  } @else {
    <mat-hint>&nbsp;</mat-hint>
  }
</ng-template>
